import MovieIcon from '@mui/icons-material/Movie';
import DescriptionIcon from '@mui/icons-material/Description';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { Virtuoso } from 'react-virtuoso';
import Icon from '../../../../../Assets/Icon/CustomIcon';
import Commons from '../../../../../Services/Common/Common';
import { useAppNavigate } from '../../../../../Hooks/back/useAppNavigate';

// const statusStyles = {
//   중지: { text: '중지', bg: '#F8AEAE', color: '#BF0000' },
//   미해결: { text: '미해결', bg: '#FFE9AE', color: '#FF8A00' },
//   승인: { text: '승인', bg: '#C8F0C5', color: '#1C8B00' },
//   종료: { text: '종료', bg: '#DADADA', color: '#555555' },
// };

export default function EduList(props) {
  const { navigate } = useAppNavigate();

  return (
    <div style={{ height: '100%' }}>
      <Virtuoso
        style={{ height: '100%', paddingBottom: '2rem' }}
        data={props.workEndData || []}
        key={(index, item) => item.WORK_CD || index}
        itemContent={(index, item) => (
          <li
            style={{
              width: '100%',
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyContent: 'space-between',
              border: '1px solid #DFD9D9',
              padding: '0.8rem 1rem',
              borderRadius: '0.5rem',
              backgroundColor: 'transparent',
              cursor: 'default',
              fontSize: '16px',
              minHeight: '5rem',
              marginBottom: '0.5rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <div style={{ display: 'grid', height: '100%', width: '100%' }}>
                <div
                  style={{
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center',
                  }}
                >
                  <p style={{ fontSize: '14px' }}>
                    {item.DEP_NM1}
                    {item.DEP_NM2 && ` > ${item.DEP_NM2}`}
                    {item.DEP_NM3 && ` > ${item.DEP_NM3}`}
                    {item.DEP_NM4 && ` > ${item.DEP_NM4}`}{' '}
                  </p>
                </div>

                <Box
                  component="div"
                  sx={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    cursor: 'pointer',
                    padding: '4px 6px',
                    borderRadius: '6px',
                    transition: 'all 120ms ease-in-out',
                    minWidth: 0,
                    '&:hover': {
                      backgroundColor: '#F9F9FB',
                      boxShadow: 'inset 0 0 0 1px #ECECEC',
                    },
                  }}
                  role="button"
                  onClick={(e) => {
                    navigate(`/M_TrainingPage/video/${item.DEP_CD}`);
                  }}
                >
                  <MovieIcon
                    sx={{ fontSize: 18, color: '#FF6F61', flexShrink: 0 }}
                  />
                  <span
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      minWidth: 0,
                    }}
                  >
                    {item.VIDEO_FILE_NAME}
                  </span>
                </Box>
                <Box
                  component="div"
                  sx={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    cursor: 'pointer',
                    padding: '4px 6px',
                    borderRadius: '6px',
                    transition: 'all 120ms ease-in-out',
                    minWidth: 0,
                    '&:hover': {
                      backgroundColor: '#F9F9FB',
                      boxShadow: 'inset 0 0 0 1px #ECECEC',
                    },
                  }}
                  role="button"
                  onClick={(e) => {
                    navigate(`/M_TrainingPage/edu/${item.DEP_CD}`);
                  }}
                >
                  <DescriptionIcon
                    sx={{ fontSize: 18, color: '#42A5F5', flexShrink: 0 }}
                  />
                  <span
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      minWidth: 0,
                    }}
                  >
                    {item.EDU_FILE_NAME}
                  </span>
                </Box>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '5px',
                        fontSize: '14px',
                      }}
                    >
                      <p style={{ fontWeight: 'bold', color: '#615e5eff' }}>
                        {item.NAME}
                      </p>
                      <p>{item.POSITION}</p>
                    </div>
                    <p
                      style={{
                        color: '#968787',
                        lineHeight: '1',
                        fontSize: '14px',
                      }}
                    >
                      {dayjs(item.UPDATE_DATE).format('YYYY-MM-DD')}
                    </p>
                  </div>
                  {(item.USER_ID ===
                    Commons.DecryptoAES(props.userInfo.userid) ||
                    props.userInfo?.AUTH_CD === 'HEAD_MANAGER' ||
                    props.userInfo?.AUTH_CD === 'BUSINESS_OWNER') && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <button
                        style={{
                          backgroundColor: 'transparent',
                          border: 'none',
                          height: '24px',
                        }}
                        onClick={(e) => {
                          navigate(`/M_TrainingPage/write/${item.DEP_CD}`);
                        }}
                      >
                        <Icon.Pencil width={20} color={'#7268FF'} />
                      </button>

                      {/* <button
                          style={{
                            backgroundColor: 'transparent',
                            border: 'none',
                            height: '24px',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            props.setSelectedWorkInfo(item);
                            dispatch(BottomSheetActions.SetBottomSheetState({
                              bottom: true,
                              type: 'delete',
                            }));
                          }}
                        >
                          <Icon.Trash width={20} color={'#FF6868'} />
                        </button> */}
                    </Box>
                  )}
                </div>
              </div>
            </div>
          </li>
        )}
        components={{
          Footer: () => <div style={{ height: '1rem' }} />,
        }}
      />
    </div>
  );
}
